import { useState, type ReactNode } from "react";
import { cn } from "@/lib/utils";

// Minimal-Tooltip ohne Radix-Dep. Show on hover/focus, lifecycle nur via mouse-events.
// Reicht für UTC-Date-Anzeige + ähnliche Hints in M1.
interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Tooltip({ content, children, className }: TooltipProps) {
  const [open, setOpen] = useState(false);
  return (
    <span
      className={cn("relative inline-block", className)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      {children}
      {open && content && (
        <span
          role="tooltip"
          className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-mantle px-2 py-1 text-xs text-text border border-border shadow"
        >
          {content}
        </span>
      )}
    </span>
  );
}
